export const checkBoxStyle = {
  marginTop: '0.25rem',
  width: 15,
  height: 15,
};
export const col8Style = { size: 8, offset: 2 };
export const col10Style = { size: 10, offset: 1 };
export const col12Style = { size: 12 };

